
<script>
import appConfig from '@src/app.config'
import UserInbox from '../../components//Users/UserInbox.vue'
import UserScheduler from '../../components/Users/AppScheduler.vue'
import DefaultsVue from '../../components/Users/Defaults.vue';

export default {
  page: {
    title: 'Inbox'
  },
  name: 'UserPage',
  components: {
    'User-Inbox': UserInbox,
    'User-Scheduler': UserScheduler,
    'defaults' : DefaultsVue
  },
  data(){
    return {
      active: 0,
    }
  }
}
</script>

<template>
  <v-layout row wrap align-center>
    <v-flex xs12>
      <div>
        <v-card elevation="1">
        <v-tabs centered v-model="active" slider-color="primary" color="Navy">
          <v-tab>Applications</v-tab>
          <v-tab-item>
            <User-Inbox></User-Inbox>
          </v-tab-item>
          <v-tab>Service Compliance</v-tab>
          <v-tab-item>
            <User-Scheduler></User-Scheduler>
          </v-tab-item>
          <!-- <v-tab>Default Payments</v-tab> -->
          <!-- <v-tab-item>
            <defaults></defaults>
          </v-tab-item> -->
        </v-tabs>
        </v-card>
      </div>
    </v-flex>
  </v-layout>
</template>


<style>
.custom-card {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 2px;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
  padding: 16px;
  margin-bottom: 10px;
  width: 100%;
  min-height: 250px;
}
</style>



